// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/footer.css
// module id = 2010
// module chunks = 2